import React from 'react'
import { useParams } from 'react-router-dom'
import CommentsSection from 'components/Comments/CommentsSection'
import { Feedback } from 'util/constants'
import ScrollableTabsList from 'ui/ScrollableTabsList';
import ScrollHideContainer from 'ui/ScrollHideContainer';

interface Props {
    feedback: Feedback
}

const FeedbackProfileTabs = ({ feedback }: Props) => {
    const { id, tab } = useParams<{ id: string; tab?: string }>();
    const selectedTab = tab || 'comments';

    //REMOVED: already have NavLink on scrollable tabs so this causes double navigation
    /*const handleTabChange = (newTab: string) => {
        navigate(`/feedback/${id}/${newTab === 'comments' ? '' : newTab}`);
    };*/

    const tabsData = [
        {
            label: 'Comments',
            route: `/feedback/${id}/comments`,
            value: 'comments',
        },
    ];

    return (
        <div className="py-0 relative">
            <ScrollHideContainer 
                className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
                hideOffset={57}
                threshold={56}
            >
                <div className="p-2">
                    <ScrollableTabsList
                        key={`feedback-${id}-tabs`}
                        tabs={tabsData}
                        selectedTab={selectedTab}
                        onTabChange={() => {}}
                    pageTitle={`Feedback ${feedback.title}`}
                    />
                </div>
            </ScrollHideContainer>
            <div className="">
                <CommentsSection
                    commentable_id={feedback.id}
                    commentable_type="feedback"
                    isEntitySection={true}
                />
            </div>
        </div>
    )
}

export default FeedbackProfileTabs
